'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);
var pbizServer = (typeof window !== "undefined" ? window.pbizServer : typeof global !== "undefined" ? global.pbizServer : null);

var appDom = require('./app-dom');
var dom;
var revealTimeout;
var hideTimeout;

var show = function(messageId) {

	window.clearTimeout(revealTimeout);

	window.clearTimeout(hideTimeout);

	reveal(messageId);

	hideTimeout = window.setTimeout(hide, 1500);

};

var reveal = function(messageId) {

	var $statusMsg = appDom.body.find('.side-panel__status-msg');
	var isVisible = $statusMsg.is('.side-panel__status-msg--is-shown');

	if (!isVisible) {

		if (!$statusMsg.length) {

			var markup = '<div class="side-panel__status-msg" data-message-id="' + messageId + '">' +
				'<div class="side-panel__status-msg-content">' + 
					pbizServer.statusMessages[messageId] +
				'</div>' +
			'</div>';

			appDom.body.append(markup);

			$statusMsg = appDom.body.find('.side-panel__status-msg');

		} else if (messageId !== $statusMsg.attr('data-message-id')) {

			$statusMsg.attr('data-message-id', messageId);
			$statusMsg.find('.side-panel__status-msg-content').html(pbizServer.statusMessages[messageId]);

		}

		revealTimeout = window.setTimeout(function() {

			$statusMsg.addClass('side-panel__status-msg--is-shown');

		}, 0);

	}

};

var hide = function() {

	appDom.body.find('.side-panel__status-msg').removeClass('side-panel__status-msg--is-shown');

};

var setupDom = function() {

	dom = {};

};

var addEventHandlers = function() {

	// nothing yet

};

var init = function() {

	setupDom();

	addEventHandlers();

};

module.exports = {
	init: init,
	show: show,
	hide: hide
};
